import { __extends, __awaiter, __generator, __decorate } from 'tslib';
import { copyToClipboard, MagicConfigMixin } from '@gig/magic-common';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { notificationService, NotificationDelay } from '@gig/magic-messaging';

var MailCodeKey = 'sweepstakes-mail-code';
var SweepstakesMailCode = /** @class */ (function (_super) {
    __extends(SweepstakesMailCode, _super);
    function SweepstakesMailCode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.codeLoading = false;
        _this.mailCode = '';
        return _this;
    }
    SweepstakesMailCode.prototype.created = function () {
        this.mailCode = localStorage.getItem(MailCodeKey) || '';
    };
    SweepstakesMailCode.prototype.getMailInCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, 3, 4]);
                        this.codeLoading = true;
                        _a = this;
                        return [4 /*yield*/, magic.methods.users.getMailInCode()];
                    case 1:
                        _a.mailCode = _c.sent();
                        localStorage.setItem(MailCodeKey, this.mailCode);
                        notificationService.success(this.$t('sweepstakes.get-mail-in-code.success'));
                        return [3 /*break*/, 4];
                    case 2:
                        _b = _c.sent();
                        notificationService.error(this.$t('sweepstakes.get-mail-in-code.error'));
                        return [3 /*break*/, 4];
                    case 3:
                        this.codeLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesMailCode.prototype.onCopy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.mailCode) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, copyToClipboard(this.mailCode)];
                    case 1:
                        _a.sent();
                        notificationService.success(this.$t('sweepstakes.get-mail-in-code.copy'), {
                            closeDelay: NotificationDelay.SHORT,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesMailCode = __decorate([
        Component({
            name: 'sweepstakes-mail-code',
        })
    ], SweepstakesMailCode);
    return SweepstakesMailCode;
}(Mixins(MagicConfigMixin)));

export default SweepstakesMailCode;
